import { EventResize, GridFeatureManager } from "@bryntum/schedulerpro";
import type { FinalizeContext } from "./FinalizeContext";
import ProjectQueueHoldMixin from "./mixins/ProjectQueueHoldMixin";

/**
 * Replaces Bryntum's default `EventResize` feature for `SchedulerPro`.
 *
 * Holds `project.crudQueue.queue()` from resize start through finalization, so CRUD
 * work queued during the gesture waits behind it. No-change resizes, aborts and
 * teardown release the hold without finalization work.
 */
export default class SwivuEventResize extends ProjectQueueHoldMixin(EventResize) {
  static $name = "EventResize";

  construct(...args: object[]) {
    super.construct(...args);

    this.client.on({
      eventResizeStart: () => this.holdProjectQueue(),
      beforeEventResizeFinalize: (event: FinalizeContext) => {
        // Resize exposes async/finalize on the event itself, not its context.
        event.async = true;
        this.runWithProjectQueue(() => event.finalize(true));
      },
      eventResizeEnd: () => this.cancelProjectQueue(),
      thisObj: this
    });
  }
}

GridFeatureManager.registerFeature(SwivuEventResize, true, "SchedulerPro");
